import { ContentElementIframe as CeIframeDefault } from '@vgn-medien-holding/vgn-fe-components';

export default function ContentElementIframe(element) {
  return <CeIframeDefault element={element} />;
}
